"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

require("core-js/modules/es6.reflect.construct.js");

require("core-js/modules/es6.symbol.js");

require("core-js/modules/es6.string.iterator.js");

require("core-js/modules/es6.object.to-string.js");

require("core-js/modules/es6.array.iterator.js");

require("core-js/modules/web.dom.iterable.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.string.link.js");

require("core-js/modules/es6.object.set-prototype-of.js");

require("core-js/modules/es6.object.get-prototype-of.js");

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactTruncate = _interopRequireDefault(require("react-truncate"));

var _MultiLineText = _interopRequireDefault(require("./MultiLineText"));

var _utils = require("../../../lib/utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var bool = _propTypes.default.bool,
    number = _propTypes.default.number,
    string = _propTypes.default.string,
    oneOfType = _propTypes.default.oneOfType,
    object = _propTypes.default.object;

var TruncatedText = /*#__PURE__*/function (_React$Component) {
  _inherits(TruncatedText, _React$Component);

  var _super = _createSuper(TruncatedText);

  function TruncatedText() {
    var _this;

    _classCallCheck(this, TruncatedText);

    _this = _super.call(this);
    _this.state = {
      truncated: false,
      expanded: false
    };
    _this.handleTruncate = _this.handleTruncate.bind(_assertThisInitialized(_this));
    _this.toggleLines = _this.toggleLines.bind(_assertThisInitialized(_this));
    _this.handleGATracking = _this.handleGATracking.bind(_assertThisInitialized(_this));
    _this.renderTruncatedText = _this.renderTruncatedText.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(TruncatedText, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      // trigger onResize with setTimeout to account for padding offset in render
      setTimeout(function () {
        _this2.donationsText && _this2.donationsText.onResize();
      }, 200);
    }
  }, {
    key: "handleTruncate",
    value: function handleTruncate(truncated) {
      if (this.state.truncated !== truncated) {
        this.setState({
          truncated: truncated
        });
      }
    }
  }, {
    key: "toggleLines",
    value: function toggleLines(e) {
      e.preventDefault();
      this.setState({
        expanded: !this.state.expanded
      });
    }
  }, {
    key: "handleGATracking",
    value: function handleGATracking() {
      var gaLabel = this.props.gaLabel;

      if (gaLabel) {
        (0, _utils.googleAnalytics)(gaLabel)();
      }
    }
  }, {
    key: "renderTruncatedText",
    value: function renderTruncatedText() {
      var _this3 = this;

      var _this$props = this.props,
          lines = _this$props.lines,
          message = _this$props.message,
          disableReadMore = _this$props.disableReadMore,
          inlineReadMore = _this$props.inlineReadMore,
          buttonText = _this$props.buttonText;
      var expanded = this.state.expanded;
      return /*#__PURE__*/_react.default.createElement(_reactTruncate.default, {
        ref: function ref(el) {
          _this3.donationsText = el;
        },
        lines: !expanded && lines,
        ellipsis: /*#__PURE__*/_react.default.createElement("span", null, "...", !inlineReadMore && /*#__PURE__*/_react.default.createElement("br", null), !disableReadMore && /*#__PURE__*/_react.default.createElement("a", {
          href: "#",
          className: "truncated-read-more",
          onClick: function onClick(e) {
            _this3.handleGATracking();

            _this3.toggleLines(e);
          }
        }, buttonText)),
        onTruncate: this.handleTruncate
      }, /*#__PURE__*/_react.default.createElement(_MultiLineText.default, {
        text: message
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
          truncated = _this$state.truncated,
          expanded = _this$state.expanded;
      var _this$props2 = this.props,
          truncatedClass = _this$props2.truncatedClass,
          link = _this$props2.link,
          disableReadLess = _this$props2.disableReadLess;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "".concat(truncatedClass, " ").concat(expanded ? 'expanded' : '')
      }, link.href ? /*#__PURE__*/_react.default.createElement("a", {
        href: link.href,
        target: link.target || '_self',
        className: link.className || ''
      }, this.renderTruncatedText()) : this.renderTruncatedText(), !truncated && expanded && !disableReadLess && /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement("a", {
        href: "#",
        className: "truncated-read-less",
        onClick: this.toggleLines
      }, "Less")));
    }
  }]);

  return TruncatedText;
}(_react.default.Component);

exports.default = TruncatedText;
TruncatedText.propTypes = {
  truncatedClass: string.isRequired,
  lines: number.isRequired,
  link: object,
  message: oneOfType([_propTypes.default.string, _propTypes.default.array]).isRequired,
  disableReadMore: bool,
  disableReadLess: bool,
  gaLabel: string,
  buttonText: string
};
TruncatedText.defaultProps = {
  truncatedClass: '',
  lines: 4,
  link: {},
  message: '',
  disableReadMore: false,
  disableReadLess: false,
  gaLabel: '',
  buttonText: 'Read More'
};